module.exports = __webpack_public_path__ + "img/thumbnail_CoquerelsSifaka_m_normal.4dd9f351.png";